import { FC } from 'react'

import { AppIcon } from '../app-icon'
import { AllIcons } from '../app-icon/types'
import { Paper } from '../paper'

import s from './styles.module.scss'

interface Option {
  name: string
  value: string
}

interface Props {
  options?: Option[]
  value?: string
  onChange?: (value: string) => void
}

export const SelectOneOptionRegular: FC<Props> = ({
  options,
  value,
  onChange,
}) => {
  return (
    <Paper padding={[8, 16]}>
      <div className={s.container}>
        {options?.map((option, index) => (
          <div
            key={index}
            className={s.option}
            onClick={() => onChange?.(option?.value)}
          >
            {option?.name}

            {option?.value === value ? (
              <AppIcon
                id={AllIcons.CHECK_MARK}
                className={s.icon}
                height={24}
                width={24}
              />
            ) : null}
          </div>
        ))}
      </div>
    </Paper>
  )
}
